import { useEffect, useState } from 'react';

const readStoredMenu = () => {
  try {
    const raw = localStorage.getItem('leftNavMenu');
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

// Shared by NavMenu, AccountMenu and MobileMenu so they all react to the
// same source of truth (the backend menu the login flow writes to localStorage).
export const useStoredMenu = () => {
  const [menu, setMenu] = useState(readStoredMenu);

  useEffect(() => {
    const handleStorageChange = () => setMenu(readStoredMenu());
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('localStorageUpdate', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('localStorageUpdate', handleStorageChange);
    };
  }, []);

  return menu;
};

export default useStoredMenu;
